<ng-template #modalLG let-modal>
  <div class="modal-header headerOfModal">
  
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

    <div class="modal-body d-flex flex-column align-items-center justify-content-center" style="padding: 30px 64px 64px 64px;width: auto">
        <p class="title1">Importer depuis un document NETADVISOR</p>
        <div >
            <p class="title2">
                Extraire les données d'un document netadvisor en utilisant le code à barres
            </p>

            <div class="form-group w-100" >
                <label for="basicInput" class="align-items-start justify-content-start">ID de référence Netadvisor</label>
                <input type="text" class="form-control" id="basicInput" placeholder="Exemple : SW-3-A8Z52" />
            </div>

        </div>


        <div class="modal-footer buttons">
            <button
                    type="button"
                    class="btn btn-primary d-flex align-items-center justify-content-center importButton"
                    style="padding: 8px 16px; font-size: 14px;"
                    [disabled]="selectedFiles.length === 0"
                    (click)="importFile()"
            >
                Importer
            </button>
            <button
                    type="button"
                    class="btn d-flex align-items-center justify-content-center annulerButton"
                    (click)="modal.dismiss('Cancel click')"
            >
                Annuler
            </button>

        </div>
    </div>

</ng-template>
